module.exports = __webpack_public_path__ + "static/media/invoice_unselected.d3f4a6ab.svg";